module.exports = __webpack_public_path__ + "img/2.d97df7f2.png";